import { CONVERSATION_CONSTANTS } from "../helpers/constants";
import IconClose from "../../../assets/icons/IconClose";

export default function MessagingHeader(props) {
    function handleCloseButtonClick(evt) {
        if (evt) {
            if (props.conversationStatus === CONVERSATION_CONSTANTS.ConversationStatus.OPENED_CONVERSATION) {
                props.endConversation();
            } else if (props.conversationStatus === CONVERSATION_CONSTANTS.ConversationStatus.CLOSED_CONVERSATION || props.conversationStatus === CONVERSATION_CONSTANTS.ConversationStatus.NOT_STARTED_CONVERSATION) {
                props.closeMessagingWindow();
            }
        }
    }

    function generateCloseButtonTitle() {
        return `${props.conversationStatus === CONVERSATION_CONSTANTS.ConversationStatus.OPENED_CONVERSATION ? `End conversation` : `Close window`}`;
    }

    return (
        <div className="messagingHeader">
            <div className="messagingHeaderText">
                Wie können wir Ihnen helfen?
            </div>
            <button
                className="messagingHeaderCloseButton"
                title={generateCloseButtonTitle()}
                onClick={handleCloseButtonClick}>
                <IconClose width={'18'} height={'18'} className="messagingHeaderCloseButtonIcon"/>
            </button>
        </div>
    )
}
